import script from "./typeAttendanceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./typeAttendanceCard.vue?vue&type=script&setup=true&lang=js"

import "./typeAttendanceCard.vue?vue&type=style&index=0&id=03c937bf&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03c937bf"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection});
